import { setCookie } from "@util/cookie";
import { VIEW_AS_PLACEHOLDER_FLAG } from "@util/viewAs";

export default function SwitchWorkspacePage() {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");

    if (token) {
        setCookie("authToken", token);
        // The staff tab says when the owner behind a view-as session is a
        // placeholder (the merchant has no login yet). It only feeds one
        // sentence of the banner; the token is what decides anything real.
        try {
            if (queryParams.get("placeholder") === "1") sessionStorage.setItem(VIEW_AS_PLACEHOLDER_FLAG, "1");
            else sessionStorage.removeItem(VIEW_AS_PLACEHOLDER_FLAG);
        } catch {
            /* storage blocked: the sentence is simply not shown */
        }
        window.location.href = "/";
        return <div>Switching workspace...</div>;
    }

    return <div>Switching workspace...</div>;
}
